// src/pages/admin/Config.jsx
import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CrudPage from '../../components/admin/CrudPage';
import { configAPI } from '../../services/api';

const CONFIG_KEYS = [
  'MD_CFG_ROUTE',
  'MD_CFG_WARNING_TYPE',
  'MD_CFG_INTERACTION_LEVEL',
  'MD_CFG_MED_CATEGORY',
  'MD_CFG_MED_SUBCATEGORY',
];

const Form = ({ form, onChange }) => (
  <>
    <div className="form-group">
      <label className="form-label required">Config Key</label>
      <select className="form-select" name="config_key" value={form.config_key || ''} onChange={onChange} required>
        <option value="">— Select Key —</option>
        {CONFIG_KEYS.map(k => <option key={k} value={k}>{k}</option>)}
      </select>
    </div>
    <div className="form-group">
      <label className="form-label required">Config Value</label>
      <input
        className="form-input"
        name="config_value"
        value={form.config_value || ''}
        onChange={onChange}
        placeholder="e.g. oral"
        style={{ fontFamily: 'var(--font-mono)' }}
        required
      />
    </div>
    <div className="form-group">
      <label className="form-label">Display Label</label>
      <input className="form-input" name="display_label" value={form.display_label || ''} onChange={onChange} placeholder="e.g. Oral" />
    </div>
    <div className="form-group">
      <label className="form-label">Sort Order</label>
      <input className="form-input" type="number" name="sort_order" value={form.sort_order || 0} onChange={onChange} />
    </div>
  </>
);

export default function Config() {
  return (
    <AdminLayout title="Config">
      <CrudPage
        title="Configs"
        subtitle="Manage global configuration key-value pairs"
        searchKey="config_key"
        columns={[
          {
            key: 'config_key', label: 'Key', render: r => (
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8125rem', background: 'var(--gray-100)', padding: '2px 8px', borderRadius: 4 }}>
                {r.config_key}
              </span>
            )
          },
          {
            key: 'config_value', label: 'Value', render: r => (
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.875rem' }}>{r.config_value}</span>
            )
          },
          { key: 'display_label', label: 'Display Label' },
          { key: 'sort_order', label: 'Order' },
        ]}
        fetchFn={async () => {
          const res = await configAPI.getAll();
          // API returns grouped object — flatten it into an array
          const data = res.data.data;
          const flat = Array.isArray(data) ? data : Object.values(data).flat();
          return { data: { data: flat } };
        }}
        createFn={configAPI.create}
        updateFn={configAPI.update}
        deleteFn={configAPI.delete}
        FormComponent={Form}
        formDefault={{ config_key: '', config_value: '', display_label: '', sort_order: 0 }}
      />
    </AdminLayout>
  );
}
